module.exports = __webpack_public_path__ + "static/hub-yellow-e3542699b2db87fddb5f0798105df999.png";